//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import React from "react";

const TutorMatchedSubject = ({ subject, toggleUpdateBtn }) => (
  <div className="request-subject">
    <a
      href={subject.url}
      target="_blank"
      onMouseEnter={() => toggleUpdateBtn(false)}
    >
      <span
        className={subject.active ? null : "request-subject-inactive"}
        title={subject.active ? "active" : "not active"}
      >
        {subject.name}
      </span>
    </a>
  </div>
);

export default TutorMatchedSubject;
